import { render, staticRenderFns } from "./FriendsMyFriends.vue?vue&type=template&id=7e923913&scoped=true&lang=pug&"
import script from "./FriendsMyFriends.vue?vue&type=script&lang=js&"
export * from "./FriendsMyFriends.vue?vue&type=script&lang=js&"
import style0 from "./FriendsMyFriends.vue?vue&type=style&index=0&id=7e923913&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e923913",
  null
  
)

export default component.exports